import { IApiService } from './api.service';
import { CrossReferencesOpinionOption } from '../../../../../../../../frontend/libs/shared/src/lib/types/product/crossess-refernces';
import { User } from './users.service';

class CrossesModalController {
  account: User;
  modalProduct;
  modalProductCrossesPromise;
  featureList;
  voteOnClick;
  addNoteOnClick;
  addCross;
  doAnimate = false;
  noProductCrossesMessage: string = 'No crosses found';
  noSearchResultsFound: string = 'No search results found';
  searchTerm: string;
  productSearchResultsAndCrosses;
  productSearchResultsAndCrossesPromise;
  cancel;
  permissions;
  getProductCrosses;
  getProduct;
  rfpId;
  hasChangeCrossReferenceOpinion;
  pageContext;
  isSeller: boolean;
  crossReferenceOpinionOptions: CrossReferencesOpinionOption[];

  constructor(
    private modalData,
    private modalPromise,
    private $scope,
    private api: IApiService,
    private $q,
    private $filter,
  ) {
    'ngInject';

    this.account = this.modalData.account;
    this.modalProduct = this.modalData.products[this.modalData.rowIndex];
    this.featureList = this.modalData.featureList;
    this.voteOnClick = this.modalData.voteOnClick;
    this.addNoteOnClick = this.modalData.addNoteOnClick;
    this.addCross = this.modalData.addCross;
    this.permissions = this.modalData.permissions;
    this.rfpId = this.modalData.rfpId;
    this.pageContext = this.modalData.pageContext;
    this.isSeller = this.modalData.isSeller;
    this.crossReferenceOpinionOptions = this.modalData.crossReferenceOpinionOptions;

    // We want to check for the existence of product crosses before calling an api to get them.
    if (!this.modalProduct.crosses) {
      this.modalProduct.crosses = null;
      this.getProductCrosses = this.api.products
        .getProductCrosses(this.modalProduct.productId)
        .then((crosses) => {
          this.modalProduct.crosses = crosses;
        });
    }

    /* We added this check for product counts since the implementation on the new ppDetails page does not have the same product data we needed to feed the modal.
     * In the case of the catalog product page we get the product from the product grid and this product has the counts we need for the top session of the modal,
     * So there is no need to call the api below.
     */
    if (
      this.modalProduct.crossApproveCount == null ||
      this.modalProduct.crossDisputeCount == null
    ) {
      this.modalProduct.crossApproveCount = null;
      this.modalProduct.crossDisputeCount = null;

      this.getProduct = this.api.products
        .getProductFromCrossReferences(this.modalProduct.productId)
        .then((product) => {
          this.modalProduct.crossApproveCount = product.crossApproveCount;
          this.modalProduct.crossDisputeCount = product.crossDisputeCount;
          this.modalProduct.productCategory = product.category.name;
          this.modalProduct.seller = product.seller;
          this.modalProduct.manufacturer = {
            id: product.manufacturer.id,
            name: product.manufacturer.name,
          };
        });
    }

    this.modalProductCrossesPromise = this.$q.all([
      this.getProductCrosses,
      this.getProduct,
    ]);
  }

  disabledPrevious() {
    return this.modalData.rowIndex === 0;
  }

  previous() {
    this.searchTerm = '';
    this.modalProduct = this.modalData.products[--this.modalData.rowIndex];

    // We want to check for the existence of product crosses before calling an api to get them.
    if (!this.modalProduct.crosses) {
      this.getProductCrosses = this.api.products
        .getProductCrosses(this.modalProduct.productId)
        .then((cross) => {
          this.modalProduct.crosses = cross;
        });
    }

    /* We added this check for product counts since the implementation on the new ppDetails page does not have the same product data we needed to feed the modal.
     * In the case of the catalog product page we get the product from the product grid and this product has the counts we need for the top session of the modal,
     * So there is no need to call the api below.
     */
    if (
      this.modalProduct.crossApproveCount == null ||
      this.modalProduct.crossDisputeCount == null
    ) {
      this.modalProduct.crossApproveCount = null;
      this.modalProduct.crossDisputeCount = null;

      this.getProduct = this.api.products
        .getProductFromCrossReferences(this.modalProduct.productId)
        .then((product) => {
          this.modalProduct.crossApproveCount = product.crossApproveCount;
          this.modalProduct.crossDisputeCount = product.crossDisputeCount;
          this.modalProduct.productCategory = product.category.name;
          this.modalProduct.seller = product.seller;
          this.modalProduct.manufacturer = {
            id: product.manufacturer.id,
            name: product.manufacturer.name,
          };
        });
    }

    this.modalProductCrossesPromise = this.$q.all([
      this.getProductCrosses,
      this.getProduct,
    ]);

    return this.modalProduct;
  }

  next() {
    this.searchTerm = '';
    this.modalProduct = this.modalData.products[++this.modalData.rowIndex];

    // We want to check for the existence of product crosses before calling an api to get them.
    if (!this.modalProduct.crosses) {
      this.getProductCrosses = this.api.products
        .getProductCrosses(this.modalProduct.productId)
        .then((cross) => {
          this.modalProduct.crosses = cross;
        });
    }

    /* We added this check for product counts since the implementation on the new ppDetails page does not have the same product data we needed to feed the modal.
     * In the case of the catalog product page we get the product from the product grid and this product has the counts we need for the top session of the modal,
     * So there is no need to call the api below.
     */
    if (
      this.modalProduct.crossApproveCount == null ||
      this.modalProduct.crossDisputeCount == null
    ) {
      this.modalProduct.crossApproveCount = 0;
      this.modalProduct.crossDisputeCount = 0;

      this.getProduct = this.api.products
        .getProductFromCrossReferences(this.modalProduct.productId)
        .then((product) => {
          this.modalProduct.crossApproveCount = product.crossApproveCount;
          this.modalProduct.crossDisputeCount = product.crossDisputeCount;
          this.modalProduct.productCategory = product.category.name;
          this.modalProduct.seller = product.seller;
          this.modalProduct.manufacturer = {
            id: product.manufacturer.id,
            name: product.manufacturer.name,
          };
        });
    }

    this.modalProductCrossesPromise = this.$q.all([
      this.getProductCrosses,
      this.getProduct,
    ]);

    return this.modalProduct;
  }

  disabledNext() {
    return this.modalData.rowIndex === this.modalData.products.length - 1;
  }

  showMessage() {
    return (
      (this.modalProduct.crosses &&
        !this.searchTerm &&
        (this.modalProduct.crosses.length === 0 ||
          this.modalProduct.crosses == null)) ||
      (this.productSearchResultsAndCrosses &&
        this.searchTerm &&
        (this.productSearchResultsAndCrosses.length === 0 ||
          this.productSearchResultsAndCrosses == null))
    );
  }

  message() {
    return !this.searchTerm
      ? this.noProductCrossesMessage
      : this.noSearchResultsFound;
  }

  onSearchTermChange(searchText) {
    if (searchText) {
      let promise;
      let cancel;

      // We check if there was a canceled from the api.
      this.productSearchResultsAndCrosses = null;
      if (this.cancel) {
        this.cancel();
      }

      ({ promise, cancel } = this.api.products.getSearchProducts(searchText));

      this.cancel = cancel;

      // We call the api
      promise.then((searchResults) => {
        let results = searchResults.products.filter(
          (result) => result.id !== this.modalProduct.id,
        );

        return (this.productSearchResultsAndCrosses = results.map((product) => {
          product.isCrossed = false;

          let matchProduct = this.modalProduct.crosses.find((cross) => {
            return cross.id === product.id;
          });

          if (matchProduct) {
            return matchProduct;
          } else {
            return product;
          }
        }));
      });

      this.productSearchResultsAndCrossesPromise = this.$q.all([promise]);
    }
  }

  getCrossProductId(product) {
    return product.productId ? product.productId : product.id;
  }

  findApplicationPermission = this.$filter('findApplicationPermission');

  addCrossInternal(fromProduct, toProduct) {
    let fromProductId = this.getCrossProductId(fromProduct);

    this.api.crossReferences
      .addCross(fromProductId, toProduct.id, this.rfpId)
      .then((cross) => {
        let indexOfCross = this.productSearchResultsAndCrosses.findIndex(
          (item) => {
            return item.id === toProduct.id;
          },
        );

        // We check that the user has the correct role to change the vote assessment before we update the vote counts.
        this.hasChangeCrossReferenceOpinion = this.findApplicationPermission(
          this.permissions,
          'UPDATE_CROSS_REFERENCE',
        );

        if (this.hasChangeCrossReferenceOpinion) {
          fromProduct.crosses.push(cross);
          this.productSearchResultsAndCrosses[indexOfCross] = cross;
          fromProduct.crossReferenceCount += 1;
          fromProduct.crossApproveCount += 1;
        }

        // Clear search field in modal after cross is added.
        this.onClearSearchTerm();

        // Add to Redux model
        this.addCross(fromProductId, cross);
      });
  }

  returnLoadingIndicatorPromise() {
    if (this.searchTerm) {
      return this.productSearchResultsAndCrossesPromise;
    } else {
      return this.modalProductCrossesPromise;
    }
  }

  returnSearchResultsCount() {
    return this.productSearchResultsAndCrosses
      ? this.productSearchResultsAndCrosses.length
      : 0;
  }

  onClearSearchTerm() {
    this.searchTerm = '';
  }
}

export class CrossesModalService {
  constructor(private $bsModal, private $q) {
    'ngInject';
  }

  openModal(
    products,
    pageContext,
    rowIndex,
    account,
    featureList,
    voteOnClick,
    addNoteOnClick,
    addCross,
    permissions,
    rfpId?,
    isSeller?: boolean,
    crossReferenceOpinionOptions?: CrossReferencesOpinionOption[],
  ) {
    let deferred = this.$q.defer();

    let theModal = this.$bsModal({
      title: `Crosses for `,
      template: require('../catalog/crosses.modal.html'),
      locals: {
        modalData: {
          products,
          pageContext,
          rowIndex,
          account,
          featureList,
          voteOnClick,
          addNoteOnClick,
          addCross,
          permissions,
          rfpId,
          isSeller,
          crossReferenceOpinionOptions,
        },
        modalPromise: deferred,
      },
      controller: CrossesModalController,
      controllerAs: '$ctrl',
    });

    // We can manipulate the modal by waiting for the modal's $promise to resolve and then calling functions. For
    // example: theModal.$promise.then(theModal.show);
    return deferred.promise;
  }
}
